<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
    :class="{ 'required': required }"
  >
    <div v-if="value">
      <slot
        name="selection"
        :remove="remove"
        :valueLabel="valueLabel"
        :value="value"
        :disabled="disabled"
      >
        <div
          class="chip"
          :class="{'is-disabled': disabled}"
        >
          {{ valueLabel }}
          <button
            v-if="!disabled"
            type="button"
            class="delete"
            @click="remove()"
          />
        </div>
      </slot>
    </div>
    <b-autocomplete
      v-else
      v-model="query"
      :data="filteredTags"
      :icon="icon"
      :placeholder="placeholder"
      :field="field"
      :maxlength="maxlength"
      :allow-new="allowNew"
      :open-on-focus="openOnFocus"
      :keep-first="keepFirst"
      :disabled="disabled"
      @select="onInput"
      @typing="onTyping"
    >
      <div slot-scope="props">
        <slot v-bind="props">
          {{ getLabel(props.option) }}
        </slot>
      </div>
    </b-autocomplete>
  </b-field>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    data: {
      required: true,
      type: Array
    },
    value: {
      default: null,
      validator (i) {
        return _.isObject(i) || _.isString(i);
      }
    },
    field: {
      default: undefined,
      type: String
    },
    icon: {
      default: "magnify",
      type: String
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    allowNew: {
      type: Boolean,
      default: false
    },
    openOnFocus: {
      type: Boolean,
      default: false
    },
    keepFirst: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      query: ""
    };
  },
  computed: {
    valueLabel () {
      return this.getLabel(this.value);
    },
    filteredTags() {
      return this.data.filter((option) => {
        let field = null;

        if (_.isString(option)) {
          field = option;
        }

        if (_.isPlainObject(option) && _.isString(option[this.field])) {
          field = option[this.field];
        }

        if (field == null) {
          return false;
        }

        return field
          .toString()
          .toLowerCase()
          .indexOf(this.query.toLowerCase()) >= 0;
      });
    }
  },
  methods: {
    onTyping (query) {
      this.$emit("typing", query);
    },
    onInput (event) {
      this.inputListener(event);
    },
    remove () {
      if (this.disabled) {
        return;
      }
      this.onInput(null);
    },
    getLabel (option) {
      if (_.isString(option)) {
        return option;
      }
      return option[this.field];
    }
  }
};
</script>
